import React from "react";
import { useTranslation } from "react-i18next";

function Timing() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/11.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{backgroundImage:'url(./images/9.jpg)',marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div className="col-md-7" style={{background:'#fffffff7',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}
                   
                    <div class="row col-md-12">
                        <div className="col-md-12 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                        <table className="table">
                            {/* <tr>
                                <td className="timelist">പള്ളിയുണർത്തൽ</td>
                                <td className="timelist">04:00 ന്</td>
                            </tr> */}
                            <tr>
                                <td className="timelist">നടതുറക്കൽ</td>
                                <td className="timelist">05:00 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">അഭിഷേകം</td>
                                <td className="timelist">05:15 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">ഗണപതിഹോമം</td>
                                <td className="timelist">06:15 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">ഉഷ:പൂജ</td>
                                <td className="timelist">07:30 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">നടയടയ്ക്കുന്നത്</td>
                                <td className="timelist">10:30 ന്</td>
                            </tr>
                        </table>
                            {/* <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">08:30 AM to 10:00 AM</li>
                                <li className="timelist">10:30 AM to 11:15 AM</li>
                                <li className="timelist">After 12:00</li>
                          </ul> */}
                         </div>
                        <div className="col-md-12 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <table className="table">
                            <tr>
                                <td className="timelist">നട തുറക്കുന്നത്</td>
                                <td className="timelist">05:00 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">ദീപാരാധന</td>
                                <td className="timelist">06:30 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">അത്താഴപൂജ</td>
                                <td className="timelist">07:30 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">നടയടയ്ക്കുന്നത്</td>
                                <td className="timelist">08:00 ന്</td>
                            </tr>
                            
                        </table>

                               
                                {/* <ul>
                                    <li className="timelist">4:30 PM to 6:15 PM</li>
                                    <li className="timelist">6:45 PM to 7:20 PM</li>
                                    <li className="timelist">After Sreeveli</li>
                                </ul> */}
                      </div>
                    </div>
                    <p className="timelist">
                <li className="timelist">{t("des")}</li>
              </p>
                </div>
                
                
           </div> 
                      
        </div>
        
        
     


      </div>
    </div>
  );
}

export default Timing;